import { Context } from '@vue-storefront/core';
import { User, ApiResult } from '../../types';
export default async function customProfile(context: Context): Promise<ApiResult> {
  const { client, config } = context;
  const url = new URL('/mall/member/profile', config.api.url);
  const { data: res } = await client.post(url.href);
  if (res.data) {
    const user: User = {
      memberId: res.data.member_id,
      email: res.data.email,
      firstName: res.data.first_name,
      lastName: res.data.last_name,
      nick: res.data.nick,
      phone: res.data.phone,
      avatar: res.data.avatar,
      createTime: res.data.create_time,
      lastIp: res.data.last_ip
    };
    res.data = user;
  }
  return res;
}
